<template>
  <div>
    <div class="flex items-center" style="margin-bottom: -1px">
      <div style="flex: 4">
        <p class="title-text">안전보건교육일지</p>
      </div>
      <table class="flex-1 sign">
        <colgroup>
          <col width="38" />
          <col />
        </colgroup>
        <tr>
          <th rowspan="2" class="gray p-0">
            <div class="flex justify-center items-center">
              <p style="writing-mode: vertical-lr">결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재</p>
            </div>
          </th>
          <th class="gray">관리감독자</th>
        </tr>
        <tr>
          <td>
            <div style="height: 100px">
              <img v-if="!!form.sign2.sign" :src="form.sign2.sign" class="w-full h-full object-contain" />
            </div>
          </td>
        </tr>
      </table>
    </div>
    <table class="contentTable" style="page-break-after: always">
      <tbody>
        <tr>
          <th>사업장명</th>
          <td colspan="2">{{ form.stdInfo.field_name }}</td>
          <th>교육일시</th>
          <td colspan="2">{{ form.education_date }}, {{ form.education_start_time }} ~ {{ form.education_end_time }}</td>
        </tr>
        <tr>
          <th>교육명</th>
          <td colspan="2">{{ form.education_name }}</td>
          <th>교육구분</th>
          <td colspan="2">{{ !!form.education_type ? form.education_type.value : "" }}</td>
        </tr>
        <tr>
          <th>교육장소</th>
          <td colspan="2">{{ form.education_location }}</td>
          <th>교육내용 반영 재해형태</th>
          <td colspan="2">{{ form.reflected_disaster_type.join(", ") }}</td>
        </tr>
        <tr>
          <th>대상(작업명)</th>
          <td colspan="5">{{ !!form.target_work ? form.target_work.value : "" }}</td>
        </tr>

        <tr>
          <th rowspan="3">교육실시자</th>
          <th>교육실시자 성명</th>
          <td colspan="4">{{ form.instructor_full_name }}</td>
        </tr>
        <tr>
          <th>교육 실시자 소속</th>
          <td colspan="4">{{ form.instructor_affiliation }}</td>
        </tr>
        <tr>
          <th>교육 실시자 직책</th>
          <td colspan="4">{{ form.instructor_position }}</td>
        </tr>

        <tr>
          <th rowspan="3">교육인원</th>
          <th>교육 대상</th>
          <td colspan="4">{{ form.education_target }}</td>
        </tr>
        <tr>
          <th>교육 실시 인원(명)</th>
          <td colspan="4">{{ form.participants_attended | comma }}</td>
        </tr>
        <tr>
          <th>교육 미실시 인원(명)</th>
          <td colspan="4">{{ form.participants_not_attended | comma }}</td>
        </tr>

        <tr class="print-container">
          <th>교육내용</th>
          <td colspan="5">
            <div class="print-textarea no-block">
              {{ form.education_content }}
            </div>
          </td>
        </tr>
        <tr class="print-container">
          <th>근로자 의견</th>
          <td colspan="5">
            <div class="print-textarea no-block">
              {{ form.worker_opinion }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!--참석자 명단-->
    <h1 class="title-text">안전보건교육 참석자 명단</h1>
    <div class="flex gap-5">
      <div class="flex-1 flex items-center">
        <div style="width: 100px; font-size: 14px; font-weight: 500; line-height: 20px; padding: 0 7px">교육구분</div>
        <span class="print-input flex-1"> {{ !!form.education_type ? form.education_type.value : "" }} </span>
      </div>
      <div class="flex-1 flex items-center">
        <div style="width: 100px; font-size: 14px; font-weight: 500; line-height: 20px; padding: 0 7px">교육일</div>
        <span class="print-input flex-1"> {{ form.education_date }}, {{ form.education_start_time }} ~ {{ form.education_end_time }}</span>
      </div>
    </div>

    <div style="margin-top: 24px" class="flex gap-3 pageBreak">
      <table class="employee">
        <colgroup>
          <col width="64" />
        </colgroup>
        <tbody>
          <tr>
            <th class="px-0">No.</th>
            <th>ID(사번)</th>
            <th>부서명</th>
            <th>직종</th>
            <th>이름</th>
            <th>서명</th>
            <th>비고</th>
          </tr>
          <tr v-for="index in 20" :key="index">
            <th class="px-0">{{ index }}</th>
            <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].employee_id : "" }}</td>
            <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].com_name : "" }}</td>
            <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].employment_type : "" }}</td>
            <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].full_name : "" }}</td>
            <td class="p-0">
              <img v-if="!!employeeList[index - 1]" :src="employeeList[index - 1].sign" class="w-full object-contain" />
            </td>
            <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].note : "" }}</td>
          </tr>
        </tbody>
      </table>
      <table class="employee">
        <colgroup>
          <col width="64" />
        </colgroup>
        <tbody>
          <tr>
            <th class="px-0">No.</th>
            <th>ID(사번)</th>
            <th>부서명</th>
            <th>직종</th>
            <th>이름</th>
            <th>비고</th>
          </tr>
          <tr v-for="index in 20" :key="index + 20">
            <th class="px-0">{{ index + 20 }}</th>
            <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].employee_id : "" }}</td>
            <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].com_name : "" }}</td>
            <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].employment_type : "" }}</td>
            <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].full_name : "" }}</td>
            <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].note : "" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 사진대지 -->
    <h1 class="title-text">안전보건교육 사진대지</h1>
    <div v-for="photo in form.photoList" :key="photo.id" v-if="photo.path" class="mb-6 photoWrap">
      <div class="photoContainer">
        <img height="600" :src="photo.path" :alt="photo.input" />
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-2">
        <div class="col-span-12 flex items-start">
          <span class="print-input"> {{ photo.input }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print107",
  props: {
    form: Object,
    employeeList: Array,
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
.title-text {
  font-size: 24px;
  font-weight: 700;
  line-height: 35px;
  text-align: center;

  padding: 40px 0;
}

table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  td,
  th {
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;

    border: 1px solid #cdcdcd;
    padding: 26px 14px;
  }
  th {
    text-align: center;
    background: #f9f9f9;
  }

  &.sign {
    th {
      padding: 10px 0;
    }
    td {
      padding: 0;
    }
  }
  &.employee {
    th,
    td {
      text-align: center;
      padding: 20px 0;
    }
  }
}

.photoContainer {
  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>
